import React, { useEffect, useRef, useState } from "react";
import localeText from "../../../../locale";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import ProductService from "../../../../service/ProductService";
import { useHistory } from "react-router-dom";
import { locale } from "../../../../utilities/locale/locale";
import { removelocalStorageToken } from "../../../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../../../utilities/sessionStorage/username";
import { listTypeProduct } from "../NewProduct/inputs";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import HeaderEditorTemplate from "../NewProduct/components/HeaderEditorTemplate/HeaderEditorTemplate";
import { Editor } from "primereact/editor";
import DOMPurify from "dompurify";
import { FileUpload } from "primereact/fileupload";
import { localeISO } from "../../../../utilities/localeIso";
import { formatPrice } from "../../../../utilities/formatPrice";

const uploadOptions = {
  className: "hidden",
};

const FringeBenefit = ({ currency = "USD", user }) => {
  const { showErrorToast } = useToastContext();

  const downloadableId = parseInt(process.env.REACT_APP_DOWNLOADABLE_ID);

  const productService = new ProductService();

  const [categories, setCategories] = useState([]);
  const [specificCategories, setSpecificCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [loadingCategories, setLoadingCategories] = useState(true);

  // Product info
  const [title, setTitle] = useState("");
  const [rules, setRules] = useState("");
  const [price, setPrice] = useState();
  const [images, setImages] = useState(null);
  const [stock, setStock] = useState(0);
  const fileUploadRef = useRef(null);
  const [selectedTypeProduct, setSelectedTypeProduct] = useState(0); // 1 === product, 2 === service, 3 === downloadable
  const [isLoadingRegisterBenefit, setIsLoadingBenefit] = useState(false);

  const Navigate = useHistory();

  // Paginator
  const [page, setPage] = useState(0);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoadingCategories(true);

        const resCategories = await productService.getCategories();

        if (cancel) return;

        if (resCategories.messageCode !== 200001) {
          showErrorToast({ code: resCategories.messageCode });
          setLoadingCategories(false);
        } else {
          setCategories(resCategories.result);
          setLoadingCategories(false);
        }
      } catch (e) {
        setLoadingCategories(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function uploadImages(image) {
    try {
      const res = await productService.postUploadImage(
        localStorage.getItem("__extraconomy_token"),
        image
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        return false;
      } else {
        return res.result;
      }
    } catch (e) {
      if (e.status === 401) {
        removelocalStorageToken();
        removelocalStorageUsername();
        Navigate.push("/login");
      } else if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadImg" });
    }
  }

  useEffect(() => {
    if (selectedSubcategory) setPage(3); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSubcategory]);

  async function registerProduct() {
    try {
      if (!selectedCategory?.id || !selectedSubcategory || !selectedTypeProduct) {
        showErrorToast({ detail: "pleaseFillOutAll" });
        return;
      }

      if (!images) {
        showErrorToast({ detail: "pleaseUploadAtLeastOne" });
        return;
      }

      if (images?.length > 1) {
        showErrorToast({ detail: "youCanOnlyChooseUpTo1" });
        return;
      }

      if (stock === 0) {
        showErrorToast({ detail: "stockGreaterThanZero" });
        return;
      }

      if (title.length === 0 || rules.length === 0 || price === 0 || !price) {
        showErrorToast({ detail: "pleaseFillOutAll" });
        return;
      }

      setIsLoadingBenefit(true);

      const productObj = {
        title: title,
        rules: rules,
        amountAvailable: stock,
        currency: currency,
        imageid1: images ? images[0] : null,
        price: price,
        productStatus: "PUBLISHED",
        subCategoryId: selectedSubcategory.id,
        username: localStorage.getItem("__extraconomy_username"),
      };

      if (images?.length > 0) {
        if (images[0]) productObj.imageid1 = await uploadImages(images[0]);
      } else {
        showErrorToast({ detail: "pleaseUploadAtLeastOne" });
        return;
      }

      const res = await productService.postRegisterFringeBenefit(productObj);

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        if (res.messageCode === 500000) console.log(res);
        return;
      }

      Navigate.push("/dashboard-list-fringe-benefit");
    } catch (e) {
      showErrorToast({ detail: "unexpectedErrorRegisterProduct" });
      console.log(e);
    } finally {
      setIsLoadingBenefit(false);
    }
  }

  const setNullProductInfo = () => {
    setTitle("");
    setRules("");
    setPrice(undefined);
    setImages(null);
    setStock(0);
    fileUploadRef.current.clear();
  };

  return (
    <div className="card border-1 border-300">
      {loadingCategories ? (
        <div className="text-center">
          <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
        </div>
      ) : (
        <>
          {/* Page 0 */}
          {loadingCategories ? (
            <div className="text-center">
              <i className="pi pi-spin pi-spinner text-8xl text-500 my-8"></i>
            </div>
          ) : (
            <div style={{ display: page !== 0 ? "none" : "block" }} className="mb-4">
              <h3 className="my-4">{localeText("typeOfProduct")}</h3>

              <p className="text-600">{localeText("clickAndSelect")}</p>
              <div className="flex mt-4">
                <div className="progress-product-current"></div>
                <div className="progress-product-unfulfilled"></div>
                <div className="progress-product-unfulfilled"></div>
                <div className="progress-product-unfulfilled"></div>
              </div>
              <div className="flex justify-content-between my-4">
                <div></div>
                <Button
                  icon="pi pi-arrow-right"
                  label={localeText("next")}
                  iconPos="right"
                  onClick={() => {
                    if (!selectedTypeProduct) showErrorToast({ detail: "pleaseSelectTypeProduct" });
                    else {
                      if (selectedTypeProduct === 3) {
                        setSelectedCategory(categories.find((cat) => cat.id === downloadableId));
                        setSubcategories(
                          categories.find((cat) => cat.id === downloadableId).subCategories
                        );
                        setPage(2);
                      } else {
                        setPage(1);
                      }
                    }
                  }}
                />
              </div>

              <ul
                className="flex align-items-center sm:justify-content-start justify-content-center gap-6 flex-wrap p-0"
                id="create-product"
              >
                {listTypeProduct.map((type) => {
                  return (
                    <li
                      key={type.title}
                      id={`c${type.title}`}
                      className="p-2 list-none lg:w-11rem md:w-11rem w-9rem h-9rem flex flex-column gap-2 align-items-center justify-content-center text-center select-category lg:mr-4 md:mr-4 border-round"
                      style={
                        selectedTypeProduct === type.type
                          ? { backgroundColor: "#46a748", color: "#ffffff" }
                          : { backgroundColor: "initial", color: "initial" }
                      }
                      onClick={() => {
                        if (type.type !== 3)
                          setSpecificCategories(
                            categories.filter((cat) => cat.id !== downloadableId)
                          );
                        if (!selectedTypeProduct) {
                          setSelectedTypeProduct(type.type);
                          if (type.type === 3) {
                            // ir direto para subcategoria
                            setSelectedCategory(
                              categories.find((cat) => cat.id === downloadableId)
                            );
                            setSubcategories(
                              categories.find((cat) => cat.id === downloadableId).subCategories
                            );
                            setPage(2);
                          } else {
                            setPage(1);
                          }
                        } else {
                          setSelectedTypeProduct(type.type);

                          if (type.type === 3) {
                            // ir direto para subcategoria
                            setSelectedCategory(
                              categories.find((cat) => cat.id === downloadableId)
                            );
                            setSubcategories(
                              categories.find((cat) => cat.id === downloadableId).subCategories
                            );
                            setPage(2);
                          } else {
                            setPage(1);
                          }
                        }
                      }}
                    >
                      {!type.image ? (
                        <div
                          className="bg-cover bg-center md:w-8rem w-11rem border-round"
                          style={{
                            background: `url(https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc=)`,
                          }}
                        ></div>
                      ) : (
                        <AdvancedImage
                          cldImg={cloudinaryInstance.image(type.image).format("webp")}
                          className="border-round img-responsive-img"
                        />
                      )}
                      <p>
                        <span>{localeText(type.title)}</span>
                      </p>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {/* Page 1 */}
          {!loadingCategories && (
            <div style={{ display: page !== 1 ? "none" : "block" }} className="mb-4">
              <h3 className="my-4">{localeText("newProductcategories")}</h3>

              <p className="text-600">{localeText("clickAndSelect")}</p>
              <div className="flex mt-4">
                <div className="progress-product-fulfilled w-full"></div>
                <div className="progress-product-current w-full"></div>
                <div className="progress-product-unfulfilled w-full"></div>
                <div className="progress-product-unfulfilled w-full"></div>
              </div>
              <div className="flex justify-content-between my-4">
                <Button
                  icon="pi pi-arrow-left"
                  label={localeText("previous")}
                  iconPos="left"
                  onClick={() => setPage(0)}
                />
                <Button
                  icon="pi pi-arrow-right"
                  label={localeText("next")}
                  iconPos="right"
                  onClick={() => {
                    if (!selectedCategory) showErrorToast({ detail: "pleaseSelectCategory" });
                    else setPage(2);
                  }}
                />
              </div>
              <ul className="flex align-items-center sm:justify-content-start justify-content-center flex-wrap p-0 gap-6">
                {specificCategories.map((category) => {
                  return (
                    <li
                      key={category.id}
                      id={`c${category.id}`}
                      className="p-2 list-none lg:w-11rem md:w-11rem w-9rem h-9rem flex flex-column gap-2 align-items-center justify-content-center text-center select-category lg:mr-4 md:mr-4 border-round"
                      style={
                        selectedCategory?.id === category.id
                          ? { backgroundColor: "#46a748", color: "#ffffff" }
                          : { backgroundColor: "initial", color: "initial" }
                      }
                      onClick={() => {
                        if (!selectedCategory) {
                          setSelectedSubcategory(null);
                          setSelectedCategory(category);
                          setSubcategories(category.subCategories);
                          setPage(2);
                        } else {
                          setSelectedSubcategory(null);
                          setSelectedCategory(category);
                          setSubcategories(category.subCategories);
                          setPage(2);
                        }
                      }}
                    >
                      {!category.imageid ? (
                        <div
                          className="bg-cover bg-center img-responsive-img border-round"
                          style={{
                            background: `url(https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc=)`,
                          }}
                        ></div>
                      ) : (
                        <AdvancedImage
                          cldImg={cloudinaryInstance.image(category.imageid).format("webp")}
                          className="border-round img-responsive-img"
                        />
                      )}

                      <div className="mb-2">
                        {locale === "en" && <span>{category.descriptionEnglish}</span>}
                        {locale === "it" && <span>{category.descriptionItalian}</span>}
                        {locale === "pt" && <span>{category.descriptionPortuguese}</span>}
                        {locale === "es" && <span>{category.descriptionSpanish}</span>}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {/* Page 2 */}
          <div style={{ display: page !== 2 ? "none" : "block" }} className="mb-4">
            <h3 className="my-4">{localeText("subcategories")}</h3>
            <p className="text-600">{localeText("clickAndSelect")}</p>
            <div className="flex mt-4">
              <div className="progress-product-fulfilled w-full"></div>
              <div className="progress-product-fulfilled w-full"></div>
              <div className="progress-product-current w-full"></div>
              <div className="progress-product-unfulfilled w-full"></div>
            </div>
            <div className="flex justify-content-between my-4">
              <Button
                icon="pi pi-arrow-left"
                label={localeText("previous")}
                iconPos="left"
                onClick={() => (selectedTypeProduct === 3 ? setPage(0) : setPage(1))}
              />
              {subcategories.length > 0 && (
                <Button
                  icon="pi pi-arrow-right"
                  label={localeText("next")}
                  iconPos="right"
                  onClick={() => {
                    if (!selectedSubcategory && subcategories.length > 0)
                      showErrorToast({ detail: "pleaseSelectSubcategory" });
                    else setPage(3);
                  }}
                />
              )}
            </div>
            {subcategories.length > 0 ? (
              <ul className="flex align-items-center sm:justify-content-start justify-content-center flex-wrap p-0 gap-6">
                {subcategories.map((subcategory) => {
                  return (
                    <div
                      key={subcategory.id}
                      id={`s${subcategory.id}`}
                      className="p-2 list-none lg:w-11rem md:w-11rem w-9rem h-9rem flex flex-column gap-2 align-items-center justify-content-center text-center select-category lg:mr-4 md:mr-4 border-round"
                      style={
                        selectedSubcategory?.id === subcategory.id
                          ? { backgroundColor: "#46a748", color: "#ffffff" }
                          : { backgroundColor: "initial", color: "initial" }
                      }
                      onClick={() => {
                        if (!selectedSubcategory) {
                          setSelectedSubcategory(subcategory);
                          setNullProductInfo();

                          fileUploadRef.current.clear();
                          setPage(3);
                        } else if (
                          selectedSubcategory &&
                          selectedSubcategory.id === subcategory.id
                        ) {
                          setPage(3);
                        } else {
                          setSelectedSubcategory(subcategory);
                          setNullProductInfo();

                          fileUploadRef.current.clear();
                          setPage(3);
                        }
                      }}
                    >
                      <li>
                        <div className="flex justify-content-center">
                          {!subcategory.imageid ? (
                            <div
                              className="bg-cover bg-center img-responsive-img border-round"
                              style={{
                                background: `url(https://media.istockphoto.com/vectors/thumbnail-image-vector-graphic-vector-id1147544807?k=20&m=1147544807&s=612x612&w=0&h=pBhz1dkwsCMq37Udtp9sfxbjaMl27JUapoyYpQm0anc=)`,
                              }}
                            ></div>
                          ) : (
                            <AdvancedImage
                              cldImg={cloudinaryInstance.image(subcategory.imageid).format("webp")}
                              className=" border-round img-responsive-img"
                            />
                          )}
                        </div>
                      </li>
                      <li className="mb-2">
                        {locale === "en" && <span>{subcategory.descriptionEnglish}</span>}
                        {locale === "it" && <span>{subcategory.descriptionItalian}</span>}
                        {locale === "pt" && <span>{subcategory.descriptionPortuguese}</span>}
                        {locale === "es" && <span>{subcategory.descriptionSpanish}</span>}
                      </li>
                    </div>
                  );
                })}
              </ul>
            ) : (
              <div className="text-center my-8">
                <h4>{localeText("noSubcategories")}</h4>
              </div>
            )}
          </div>

          {/* Page 3 */}
          <div style={{ display: page !== 3 ? "none" : "block" }} className="mb-4">
            <h3 className="my-4">{localeText("productInfo")}</h3>
            <p className="text-600">{localeText("productFields")}</p>
            <div className="flex mt-4">
              <div className="progress-product-fulfilled w-full"></div>
              <div className="progress-product-fulfilled w-full"></div>
              <div className="progress-product-fulfilled w-full"></div>
              <div className="progress-product-current w-full"></div>
            </div>
            <div className="flex justify-content-between my-4">
              <Button
                icon="pi pi-arrow-left"
                label={localeText("previous")}
                iconPos="left"
                onClick={() => {
                  setNullProductInfo();
                  setPage(2);
                }}
              />
            </div>

            <div className="grid mt-6 newproductContainer">
              <div className="col-12">
                <label htmlFor="title">{localeText("title")}</label>
                <InputText
                  className="w-full my-2"
                  name="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <label htmlFor="rules">{localeText("rulesToUse")}</label>
                <Editor
                  headerTemplate={<HeaderEditorTemplate />}
                  value={rules}
                  className="my-2"
                  onTextChange={(e) => setRules(DOMPurify.sanitize(e.htmlValue))}
                  style={{ height: "256px" }}
                />
              </div>

              <div className="lg:col-4 md:col-4 col-12 w-full lg:w-4 md:w-4">
                <div className="mb-3">
                  <p>
                    {localeText("price")}: {currency} {price ? formatPrice(price) : "0,00"}
                  </p>
                  <p>
                    {localeText("cashbackForBuyer")} (-1%): {currency} -
                    {price ? formatPrice(price * 0.01) : "0,00"}
                  </p>
                  <p>
                    {localeText("cashbackToBuyersSponsor")} (-1%): - {currency}{" "}
                    {price ? formatPrice(price * 0.01) : "0,00"}
                  </p>
                  <p>
                    {localeText("cashbackToSellersSponsor")} (-1%): - {currency}{" "}
                    {price ? formatPrice(price * 0.01) : "0,00"}
                  </p>
                  <p>
                    {localeText("platformFee")} (-{user.fringeBenefitTax}%): - {currency}{" "}
                    {price ? formatPrice(price * (user.fringeBenefitTax / 100)) : "0,00"}
                  </p>
                  <p>
                    {localeText("amountToBeReceived")}: {currency}{" "}
                    {price
                      ? formatPrice(
                          price - price * (user.fringeBenefitTax / 100) - price * 0.01 * 3
                        )
                      : "0,00"}
                  </p>
                </div>
                <div className="w-full">
                  <label htmlFor="price">{localeText("price")}:</label>

                  <InputNumber
                    mode="currency"
                    currency={currency}
                    locale={localeISO}
                    className="w-full my-2"
                    name="price"
                    value={price}
                    onValueChange={(e) => setPrice(e.value)}
                  />
                </div>
                <div className="w-full">
                  <label htmlFor="stock">{localeText("availableStock")}</label>

                  <InputNumber
                    className="w-full my-2"
                    name="stock"
                    value={stock}
                    onValueChange={(e) => setStock(e.value)}
                  />
                </div>
              </div>

              <div className="lg:col-4 md:col-4 col-12 w-full lg:w-8 md:w-8">
                <div className="flex justify-content-start gap-2 align-items-center">
                  <label htmlFor="imagesproduct">
                    <span>{localeText("previewImages")}</span>
                  </label>
                </div>

                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  className="mt-2"
                  name="imagesproduct"
                  onSelect={(e) => {
                    if (images?.length > 1) {
                      setImages((prevImages) => {
                        return [...(prevImages || []), ...e.files];
                      });
                      showErrorToast({ detail: "youCanOnlyChooseUpTo1" });
                      fileUploadRef.current.setFiles(images);
                      // setImages(null);
                      // fileUploadRef.current.clear(); // Limpa o campo de upload
                      return;
                    }

                    // Verifica se algum arquivo ultrapassa o limite de 10MB
                    const isFileTooBig = Array.from(e.files).some((file) => {
                      if (file.size / 1024 / 1024 > 10) {
                        showErrorToast({ detail: "fileSizeTooBig" });
                        return true;
                      }
                      return false;
                    });

                    if (!isFileTooBig) {
                      setImages((prevImages) => {
                        return [...(prevImages || []), ...e.files];
                      });
                    } else {
                      // Limpa o campo se o arquivo for grande demais
                      fileUploadRef.current.clear();
                    }
                  }}
                  onClear={() => {
                    setImages(null);
                  }}
                  onRemove={(e) => {
                    setImages((prev) => prev.filter((img) => img.name !== e.file.name));
                  }}
                  onError={() => {
                    fileUploadRef.current.clear();
                    setImages(null);
                  }}
                  onValidationFail={() => {
                    fileUploadRef.current.clear();
                    setImages(null);
                  }}
                  accept="image/*"
                  ref={fileUploadRef}
                  multiple
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "3em" }}></i>
                      <h3 className="text-400">{localeText("dragImgs")}</h3>
                    </div>
                  }
                />
                <p className="text-600 mt-2">(max. 10 MB)</p>
              </div>
            </div>

            <div className="flex justify-content-between my-4">
              <Button
                icon="pi pi-arrow-left"
                label={localeText("previous")}
                iconPos="left"
                onClick={() => setPage(2)}
              />

              <Button
                label={localeText("registerAndPublishFringeBenefit")}
                icon="pi pi-arrow-right"
                iconPos="right"
                onClick={registerProduct}
                disabled={isLoadingRegisterBenefit}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FringeBenefit;
